import Footer from "./Footer";

function DownSection({lang, swiper}) {
    return (
        <Footer lang={lang} swiper={swiper}/>
    );
}

export default DownSection;